module.exports = __webpack_public_path__ + "a06da7f0950f9dd366fc9db9d56d618a.woff2";